import { Link } from "react-router-dom";
import styles from "./Button.module.scss";

const PrimaryButton = ({
  path = "",
  title = "",
  icon = "",
  type = "button",
  onClick = () => {},
  style = {},
  className = "",
}) => {
  return (
    <>
      {type === "button" || type === "submit" ? (
        <button
          type={type}
          onClick={onClick}
          className={`${styles.primaryButton} ${className || ""}`}
          style={style}
        >
          {title}&nbsp;
          {icon ? icon : null}
        </button>
      ) : type === "link" ? (
        <Link
          to={path}
          className={`${styles.primaryButton} ${className || ""}`}
          style={style}
        >
          {title}
          {icon ? icon : null}
        </Link>
      ) : null}
    </>
  );
};

export default PrimaryButton;
